import React from "react";
import {
  OnCloseArea,
  Container,
  FlagWrapper,
  Flag,
} from "./LanguageModal.styles";
import flagUK from "../../../assets/images/flags/flagUK.svg";
import flagUS from "../../../assets/images/flags/flagUS.svg";
import flagRU from "../../../assets/images/flags/flagRU.svg";
import i18n from "../../../i18n";

const LanguageModal = ({ closeModal }) => {
  const onChange = (language) => {
    i18n.changeLanguage(language);
    closeModal();
  };

  const { language } = i18n;
  const arrayFlags = [
    { img: flagUK, name: "uk" },
    { img: flagUS, name: "en" },
    { img: flagRU, name: "ru" },
  ];

  const Flags = arrayFlags.map(
    (flag) =>
      flag.name !== language.substring(0, 2) && (
        <FlagWrapper onClick={() => onChange(flag.name)} key={flag.name}>
          <Flag src={flag.img} />
        </FlagWrapper>
      )
  );

  return (
    <>
      <OnCloseArea></OnCloseArea>
      <Container>{Flags}</Container>
    </>
  );
};

export default LanguageModal;
